import styled from '@emotion/styled';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import Image from '@base/Image';
import Button from '@base/Button/Button';
import pushRoute from '@utils/pushRoute';
import { getTopologyDataByUID } from '@selectors/topologies';
import { useSelector } from 'react-redux';
import H5 from '@base/H5/H5';
import P2 from '@base/P2/P2';

const PreSubscriptionCardWrapper = styled.div`
  width: 658px;
  height: ${Spacings.SPACING_24B};
  position: relative;
  margin-top: ${Spacings.SPACING_10B};
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_6B};
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const PreSubscriptionBG = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 658px;
  height: ${Spacings.SPACING_24B};
  border-radius: ${Spacings.SPACING_2B};
  background-color: var(--color-i-green);
  opacity: 0.1;
`;
const ImageWrapper = styled.div`
  margin-right: ${Spacings.SPACING_4B};
  width: ${Spacings.SPACING_12B};
  height: ${Spacings.SPACING_12B};
`;

const PreSubsHeading = styled(H5)``;

const PreSubsText = styled(P2)`
  margin-top: ${Spacings.SPACING_1B};
  width: 406px;
  height: ${Spacings.SPACING_18};
`;

const DetailsWrapper = styled.div`
  width: 406px;
  height: ${Spacings.SPACING_12B};
  margin-right: ${Spacings.SPACING_4B};
`;

const StyledGetSubsBtn = styled(Button)`
  font-size: ${Fonts.EXTRA_SMALL};
`;

const PreSubscriptionCard = ({ state, goalUID }) => {
  const goalInfo = useSelector(getTopologyDataByUID(goalUID));
  const handleGetSubscription = () => {
    pushRoute(
      '/goal/[goalSlug]/[goalUID]/subscribe',
      `/goal/${goalInfo?.slug}/${goalInfo?.uid}/subscribe`
    );
  };
  return (
    <PreSubscriptionCardWrapper>
      <PreSubscriptionBG />
      <ImageWrapper>
        <Image
          src="doubts20/preSubscription.svg"
          width={52}
          height={52}
          alt="pre-subscription"
        />
      </ImageWrapper>
      <DetailsWrapper>
        <PreSubsHeading>{state?.heading}</PreSubsHeading>
        <PreSubsText>
          With an Unacademy subscription, ask educators your unsolved doubts
        </PreSubsText>
      </DetailsWrapper>
      <StyledGetSubsBtn
        variant="filled"
        color="green"
        label="GET SUBSCRIPTION"
        width="124px"
        maxHeight="xs"
        onClick={handleGetSubscription}
      />
    </PreSubscriptionCardWrapper>
  );
};

const DialogImageWrapper = styled.div`
  padding-top: ${Spacings.SPACING_10B};
  text-align: center;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_4B};
  }
`;

export const dialogImage = (imgSrc, imageDim = 80) => (
  <DialogImageWrapper>
    <Image src={imgSrc} alt="illustration" width={imageDim} height={imageDim} />
  </DialogImageWrapper>
);

export default PreSubscriptionCard;
